import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import About from './About';

function Aboutus() {
  return (
    <div>
        <Navbar/>
            <br />
                    <br />
                    <br />
                    <br/>
            <br />
                    <br />
        
                    <ScrollToTop smooth top="100" color="maroon" />
                    
        
        
                    <div className='aerocitykolkata'>
                        <div className='album py-1'>
                            <div className='container mt-3'>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                        <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">About us </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <About/>
                    <br/>
    </div>
  )
}

export default Aboutus